export const CURRENT_CONFIG = {

  // license
  appId: '190183', // You need to go to the development website to apply.
  appKey: 'eaa02a10ed2b59dc6d0427fa83f5570', // You need to go to the development website to apply.
  appLicense: 'LT5kqokus9JV6fI/7z6kSg/i/9FwfZihQ8A4uLONo0PZxdZ51EvQz93ctNmKAzvvr6Ty1s9UrbQIQ6EVZvuXLvH97GuwlIHiKj/TDJAfTuFZb1sHJYqV4tuXw7GyaqrHDwwbl3r9yn+gsnq60bNG84aj4/Qdkpmp5nJ3Iq1km8=', // You need to go to the development website to apply.

  // http
  baseURL: 'https://security.lomingointernational.com/', // This url must end with "/". Example: 'http://192.168.1.1:6789/'
  websocketURL: 'wss://security.lomingointernational.com/api/v1/ws', // Example: 'ws://192.168.1.1:6789/api/v1/ws'

  // livestreaming
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  rtmpURL: 'rtmp://159.195.66.242/live/', // Example: 'rtmp://192.168.1.1/live/'
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: 'Please enter the server ip.',
  gbServerPort: 'Please enter the server port.',
  gbServerId: 'Please enter the server id.',
  gbAgentId: 'Please enter the agent id',
  gbPassword: 'Please enter the agent password',
  gbAgentPort: 'Please enter the local port.',
  gbAgentChannel: 'Please enter the channel.',
  // RTSP
  rtspUserName: 'Please enter the username.',
  rtspPassword: 'Please enter the password.',
  rtspPort: '8554',
  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',

  // map
  // You can apply on the AMap website.
  amapKey: 'Please enter the amap key.',

}
